import React, { useEffect, useState } from 'react'
import 'regenerator-runtime/runtime'
import PropTypes from 'prop-types';
import { ThemeProvider } from '../context/theme-context';
import Header from './header';
import '../assets/styles/main.scss';
import Cart from '../components/cart';
import Lightbox from '../components/lightbox';
import Footer from './footer';
import Popup from '../components/popup';
import { breakpoints } from '../utils/helpers';
import { SEOContext } from 'gatsby-plugin-wpgraphql-seo';
import { useStaticQuery, graphql } from 'gatsby';
import FixedPhoneNumber from './fixed-phone-number';

const Layout = ({ children }) => {
    const [isMobile, setIsMobile] = useState(false);

    const { wp: { seo } } = useStaticQuery(graphql`
        query SiteInfoQuery {
            wp {
                seo {
                    contentTypes {
                        post {
                            title
                            schemaType
                            metaRobotsNoindex
                            metaDesc
                        }
                        page {
                            metaDesc
                            metaRobotsNoindex
                            schemaType
                            title
                        }
                    }
                    webmaster {
                        googleVerify
                        yandexVerify
                        msVerify
                        baiduVerify
                    }
                    schema {
                        companyName
                        personName
                        companyOrPerson
                        wordpressSiteName
                        siteUrl
                        siteName
                        inLanguage
                        logo {
                            sourceUrl
                            mediaItemUrl
                            altText
                        }
                    }
                    social {
                        facebook {
                            url
                            defaultImage {
                                sourceUrl
                                mediaItemUrl
                            }
                        }
                        instagram {
                            url
                        }
                        linkedIn {
                            url
                        }
                        mySpace {
                            url
                        }
                        pinterest {
                            url
                            metaTag
                        }
                        twitter {
                            username
                            cardType
                        }
                        wikipedia {
                            url
                        }
                        youTube {
                            url
                        }
                    }
                }
            }
        }
    `);

    useEffect(() => {
        const scale = () => {
            setIsMobile(window.innerWidth < breakpoints.lg);
        }

        window.addEventListener('resize', scale);
        window.dispatchEvent(new Event('resize'));

        return () => {
            window.removeEventListener('resize', scale)
        }
    }, [])
    return (
        <SEOContext.Provider value={{ global: seo }}>
            <ThemeProvider>
                <Header isMobile={isMobile} />
                <FixedPhoneNumber />
                <Cart />
                <Popup />
                <Lightbox />
                <main className="Main" id="main-content">{children}</main>
                <Footer />
            </ThemeProvider>
        </SEOContext.Provider>
    )
}

Layout.propTypes = {
    children: PropTypes.node.isRequired,
}

export default Layout